import { lazy, Suspense } from "react";
import SEOHead from "@/components/SEOHead";
import HeroSection from "@/components/HeroSection";

// Below-the-fold: lazy-load to slim the initial bundle
const CategoryCards = lazy(() => import("@/components/CategoryCards"));
const DepartmentGrid = lazy(() => import("@/components/DepartmentGrid"));
const DealCarousel = lazy(() => import("@/components/DealCarousel"));
const FeaturedProducts = lazy(() => import("@/components/FeaturedProducts"));
const DepartmentSections = lazy(() => import("@/components/DepartmentSections"));
const TopSellers = lazy(() => import("@/components/TopSellers"));
const LimitedDropBanner = lazy(() => import("@/components/LimitedDropBanner"));
const MarketingBanner = lazy(() => import("@/components/MarketingBanner"));
const ReviewsSection = lazy(() => import("@/components/ReviewsSection"));
const Newsletter = lazy(() => import("@/components/Newsletter"));
const AIRecommendations = lazy(() => import("@/components/AIRecommendations"));

const Fallback = () => <div className="min-h-[200px]" />;

const Index = () => {
  const homepageJsonLd = [
    {
      "@type": "WebPage",
      "name": "Grovefan — Gaming Gear, Merch & Collectibles",
      "description": "Shop India's gamer-first marketplace. Mice, keyboards, headsets, capture cards, esports merch, figurines & collectibles. Free shipping above ₹999.",
      "url": "https://grovefan.lovable.app/",
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://grovefan.lovable.app/" },
      ],
    },
    {
      "@type": "Store",
      "name": "Grovefan",
      "url": "https://grovefan.lovable.app",
      "priceRange": "₹₹",
      "description": "India's gamer-first marketplace — peripherals, audio, setup gear, merch & collectibles. Free shipping above ₹999.",
      "paymentAccepted": "UPI, Credit Card, Debit Card, Net Banking, Cash on Delivery",
      "currenciesAccepted": "INR",
    },
  ];

  // Each section gets its own Suspense boundary so a slow chunk (e.g. AI
  // recommendations) doesn't block earlier sections from painting.
  const sections = [
    CategoryCards,
    DepartmentGrid,
    DealCarousel,
    FeaturedProducts,
    DepartmentSections,
    TopSellers,
    AIRecommendations,
    MarketingBanner,
    LimitedDropBanner,
    ReviewsSection,
    Newsletter,
  ];

  return (
    <div className="relative">
      <SEOHead canonical="/" jsonLd={homepageJsonLd} />
      <HeroSection />
      <div className="relative cv-auto">
        {sections.map((Section, i) => (
          <Suspense key={i} fallback={<Fallback />}>
            <Section />
          </Suspense>
        ))}
      </div>
    </div>
  );
};

export default Index;
